import mitt from 'mitt';
import { btnTd } from '@/api/typing';
import defaultSlotList from '@/components/page-model/slotList';
import { reactive } from 'vue';
import { delete_back_order } from '@/api/jms-model';
import { message } from 'ant-design-vue';
import modalBox from '@/components/form-modal/modal-tools';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
export const event_obj = mitt();
export const btn_list = [
  {
    name: '作废',
    clazz: 'danger',
    cb: (data: any) => {
      const editModal = reactive({
        visible: true,
        loading: false,
        title: '作废',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
            col: [],
          },
          fields: [
            {
              type: 'textarea',
              name: 'mark',
              label: '备注',
              disabled: false,
              allowClear: true,
              inputType: 'text',
              maxlength: 300,
              defaultValue: '',
              placeholder: '请填写备注',
            },
          ],
          rules: {},
          model: reactive({
            org_id: current_org?.id,
            is_active: true,
            mark: null,
            backorder_id: Number(data.id),
          }),
        },
        options: {},
        ok: (payload: any) => {
          return new Promise(resolve => {
            editModal.loading = true;
            delete_back_order(payload)
              .then(() => {
                message.success('作废成功');
                event_obj.emit('refresh');
                resolve(null);
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
        },
      });
      modalBox(editModal);
    },
  },
];
export const slotList = defaultSlotList;
export const config = {
  creatCol: [],
  updateCol: [],
};

export const head_btn_list: btnTd[] = [];
